<script>
import VS2 from "@gf/vue-script2";

export default {
    name: 'GfAnalyticsMixin',
    data() {
    return {      
      scriptLoader: VS2
    };
  },
    methods: {
        initialize(ids) {
           var firstID = ids[0];
           this.scriptLoader.load(
            `https://www.googletagmanager.com/gtag/js?id=${firstID}`                
            ).then(() => {
                this.analytics('js', new Date());
                for (var i = 0; i < ids.length ; i++) {                    
                    this.analytics('config', ids[i]);
                }
            });
        },
        analytics(...args){                                     
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(...args);                
        }
    }
}
</script>
